<template>
  <div class="image-grid-container">
    <span 
      v-for="(media, index) in images" 
      class="grid-item" 
      :key="media.id"
      :class="{half: isHalf(index)}"
    >
      <ResponsiveImage 
        v-if="coverMime(media) === 'image'"  
        v-bind="media"
        :isResponsive="true"
        :sizes="!isHalf(index) ? '(max-width: 768) 90vw, 70vw' : '(max-width: 768) 90vw, 20vw'" 
      />
      <ResponsiveVideo 
        v-else-if="coverMime(media) === 'video'"  
        v-bind="media" 
        :autoplay="true" 
        :loop="true"
      />
    </span>
  </div>
</template>

<script>
import ResponsiveImage from './ResponsiveImage.vue';
import ResponsiveVideo from './ResponsiveVideo.vue';

export default {
  name: 'ImageGrid',
  props: {
    images: Array,
    aspect: {
      type: Number, 
      default: 9/16,
    },  
  },
  components: {
    ResponsiveImage,
    ResponsiveVideo,
  },
  methods: {
    coverMime(image) {
      let coverMime = image && image.mime && image.mime.split('/')[0];
      return coverMime; 
    },
    isHalf(index) {
      return ((index+1) % 3 == 2 || (index+1) % 3 == 0)
    },
  }
}
</script>

<style lang="sass" scoped>
@import '../assets/partials/vars'

.image-grid-container 
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  position: relative

  .grid-item
    margin: 1% 0
    width: 100%
    
    .image-container

@media only screen and (min-width: 768px)  

    .image-grid-container 
      .image-container
        &.half
          width: 49%

      

</style>
